(function () {
  'use strict';

  // TODO: campbell, chekbox pay in full is not working propertly
  // what about if the sum of all documents exceds the amount entered ??

  angular.module('app').component('receivedPaymentDetail', receivedPaymentDetail());

  function receivedPaymentDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        company: '<',
        document: '<', // invoice, booking
        hideFilters: '<',
        showActionsFromModal: '<',
        onReceivedPaymentSaved: '&',
        onReceivedPaymentCanceled: '&',
      },
      controller: ReceivedPaymentDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/received-payments/received-payment-detail/received-payment-detail.component.html',
    };
  }

  ReceivedPaymentDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'ModalWindowConfirmService',
    'SessionService',
    'AbilityService',
    'moment',
    '$routeParams',
    'ReceivedPaymentService',
    'ClientService',
    'DocumentTypeService',
    'ExchangeRateService',

    // Angular downgraded service
    'companyService',
    'currencyService',
  ];

  function ReceivedPaymentDetailComponent(
    config,
    UtilService,
    ModalWindowConfirmService,
    SessionService,
    AbilityService,
    moment,
    $routeParams,
    ReceivedPaymentService,
    ClientService,
    DocumentTypeService,
    ExchangeRateService,

    // Angular downgraded service
    companyService,
    currencyService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_receivedpayment_accountadmin'),
      canUpdate: AbilityService.can('update_receivedpayment_accountadmin'),
    };

    vm.dateDisplay = config.DATE_DISPLAY;
    vm.dateDisplayShort = config.DATE_DISPLAY_SHORT;

    vm.saleTypes = config.SALE_TYPES;

    vm.minTotalAmount = 0;
    vm.totalPrice = 0;
    vm.receivedPaymentFromInvoice = false;
    vm.filterByDocumentNumber = '';
    vm.filterByDocumentType = [];
    vm.receivedPayment = {};

    // private properties
    let userLanguageCode = SessionService.getUserLanguage().code;

    vm.$onInit = function () {
      if (vm.item.id) {
        // view - edit
        setItemOptions(vm.item, vm.mode);

        // vm.documentDate = moment(vm.item.date);
        vm.documentDate = vm.UtilService.startOfDayFormat(vm.item.date); // yyyy-mm-ddT06:00:00.000Z
      } else {
        // new
        vm.createMode = true;

        if ($routeParams && $routeParams.invoiceId) {
          vm.receivedPaymentFromInvoice = true;
          vm.selectedCurrencyId = $routeParams.currencyId;
          vm.selectedInvoiceId = $routeParams.invoiceId;

          getClient($routeParams.clientId);
        }

        if (vm.showActionsFromModal === undefined) vm.showActionsFromModal = true;

        vm.hideFilters = vm.hideFilters || false;

        if (vm.document) {
          vm.receivedPaymentDocuments = [];
          // vm.receivedPaymentDocuments.push(vm.item.received_payment_documents[0]);
          // vm.receivedPaymentDocuments.push(vm.item.received_payment_documents);

          vm.receivedPaymentDocuments.push(vm.item.received_payment_documents);

          // console.log('HERE');
          // console.log(vm.item);
        }

        let item = {
          date: moment(),
          company_id: vm.company.id,
          user_id: SessionService.currentUser().id,
          currency_id: null,
          currency: null,
          client_id: null,
          client: null,
          amount: 0,
        };

        vm.amountAppliedToDocuments = 0;

        if (!vm.document) {
          getCurrencies(vm.company.currency_ids);

          item.currency_id = vm.company.currency_id;
        } else {
          if (!vm.document.currency) {
            getCurrencies(vm.company.currency_ids);
          }

          item.client = vm.document.client;
          item.client_id = vm.document.client_id;
          item.currency = vm.document.currency;
          item.currency_id =
            vm.document.currency_id === undefined
              ? vm.company.currency_id
              : vm.document.currency_id;
          item.amount = vm.item.amount;

          vm.minTotalAmount = vm.item.amount;
          vm.totalPrice = vm.item.amount;

          calculateAmountApplied();
        }

        vm.item = item;

        getDocumentTypes();

        vm.documentDate = moment();
        vm.incomingPaymentMethods = vm.company.payment_methods.filter(
          (paymentMethod) => paymentMethod.incoming
        );
      }
    };

    // public methods
    // -----------------------
    vm.selectDocumentType = function (documentType) {
      if (documentType.id === vm.lastDocumentTypeId) return;

      vm.documentType = documentType;
      vm.lastDocumentTypeId = documentType.id;

      vm.item.date = moment(); // needed ? check provider payment

      setPaymentDatePicker(vm.documentType);
    };

    vm.onClientSelected = function (client) {
      if (vm.receivedPaymentFromInvoice) {
        vm.item.currency_id = vm.selectedCurrencyId;
      } else {
        vm.item.currency_id = client.currency_id ? client.currency_id : vm.company.currency_id; // vm.companyBaseCurrencyId
      }

      vm.item.client_id = client.id;
      vm.item.client = client;

      let currency = vm.currenciesPerCompany.find(
        (currency) => currency.id === vm.item.currency_id
      );

      vm.selectCurrency(currency, true);

      if (vm.item.payment_method_code) {
        vm.item.payment_method_code = null;
        vm.item.payment_method_id = null;
      }
    };

    // When client is empty
    vm.onClientValidated = function (client) {
      vm.item.client = client;

      if (!vm.item.client && vm.item.client_id) {
        resetClientInput();
      }
    };

    vm.onClientCleared = function (clearObj) {
      if (clearObj) {
        vm.item.client = null;
      }

      resetClientInput();
    };

    /*vm.convertAmountToBaseAccountingCurrency = function(amount) {
            if(!vm.item.exchange_rate_value){
                return 0;
            }
            return vm.UtilService.roundNum(amount * vm.item.exchange_rate_value);
        };*/

    vm.selectCurrency = function (currency, setCurrency) {
      if (currency.id === vm.lastCurrencyId && !setCurrency) return;

      vm.item.currency = currency;
      vm.lastCurrencyId = currency.id;

      vm.documentDateExchangeRate = getDocumentDateExchangeRate(vm.item.currency_id);

      vm.item.exchange_rate_value = vm.documentDateExchangeRate.value;
      vm.item.base_currency_symbol = vm.currenciesPerCompany.find(
        (x) => x.id === vm.company.currency_id
      ).symbol;

      vm.item.amount = 0;
      vm.amountAppliedToDocuments = 0;

      if (!vm.editMode) getOpenDocuments();
    };

    vm.selectAmount = function () {
      validateAmounts();
    };

    vm.openClientInfoModal = function (client) {
      ClientService.openClientInfoModal(client);
    };

    vm.openRelatedTransactions = function () {
      ReceivedPaymentService.openRelatedTransactions(vm.item.id, vm.item.client);
    };

    vm.payInFull = function (receivedPaymentDocument) {
      if (receivedPaymentDocument.pay_in_full) {
        receivedPaymentDocument.amount = receivedPaymentDocument.balance;
      } else {
        vm.receivedPaymentDocuments.pay_in_full = false;
        receivedPaymentDocument.amount = 0;
      }

      vm.validateAmount(receivedPaymentDocument);
    };

    vm.payInFullDocuments = function (receivedPaymentDocuments) {
      if (receivedPaymentDocuments.length !== undefined) {
        if (receivedPaymentDocuments.length > 0 && receivedPaymentDocuments.pay_in_full === true) {
          receivedPaymentDocuments.forEach(function (doc) {
            doc.pay_in_full = true;
            vm.payInFull(doc);
          });
        } else {
          receivedPaymentDocuments.forEach(function (doc) {
            doc.pay_in_full = false;
            vm.payInFull(doc);
          });
        }
      }
    };

    vm.validateAmount = function (receivedPaymentDocument) {
      if (!receivedPaymentDocument.amount) {
        receivedPaymentDocument.amount = !vm.createMode
          ? receivedPaymentDocument.previousAmount
          : 0;
      } else if (receivedPaymentDocument.amount <= 0 && !vm.createMode) {
        receivedPaymentDocument.amount = receivedPaymentDocument.previousAmount;
      }

      receivedPaymentDocument.newBalance = vm.UtilService.roundNum(
        receivedPaymentDocument.balance - receivedPaymentDocument.amount
      );

      receivedPaymentDocument.pay_in_full =
        receivedPaymentDocument.amount === receivedPaymentDocument.balance;

      calculateAmountApplied();
    };

    vm.removePaymentDocument = function (index) {
      vm.receivedPaymentDocuments.splice(index, 1);
      calculateAmountApplied();
    };

    vm.openSearchOpenPayments = function () {
      let successCallback = function (openDocument) {
        vm.receivedPaymentDocuments.push(openDocument);
        calculateAmountApplied();
      };

      let filterCriteria = {
        client_id: vm.item.client_id,
        date_utc: vm.UtilService.currentDateUTCFormat(vm.item.date),
      };

      ReceivedPaymentService.openSearchOpenPayments(
        filterCriteria,
        vm.receivedPaymentDocuments,
        successCallback
      );
    };

    vm.editReceivedPayment = function () {
      const successCallback = (data) => {
        hideWarningMessageModal(data);

        vm.editMode = true;
        vm.viewMode = false;

        getDocumentTypes();

        // if (!vm.document) { // why ?
        //   getCurrencies(vm.company.currency_ids);
        // }
      };

      const cancelCallback = (data) => {
        hideWarningMessageModal(data);

        vm.editMode = false;
        vm.viewMode = true;
      };

      const showRelatedTransactions = (data) => {
        hideWarningMessageModal(data);

        vm.openRelatedTransactions();
      };

      ReceivedPaymentService.hasRelatedTransactions(vm.item.id, vm.item.client.id).then(function (
        data
      ) {
        if (data && !SessionService.isWarningMessageHidden('receivedPayments')) {
          let modalParams = {
            mode: 'warning',
            title: 'RECORD_WITH_RELATED_TRANSACTION',
            relatedTransactionButtonLabel: 'VIEW_RELATED_TRANSACTIONS',
            confirmButtonLabel: 'YES',
            cancelButtonLabel: 'NO',
            body: '',
          };

          ModalWindowConfirmService.open(
            modalParams,
            successCallback,
            cancelCallback,
            showRelatedTransactions
          );
        } else {
          successCallback;
        }
      });
    };

    /*vm.cancelEdit = function() {
            vm.item = vm.originalItem;

            setItemOptions(vm.item);
        };*/

    vm.savePayment = function (isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;
        vm.UtilService.scrollToTop();

        return;
      }

      let createPayment = function () {
        vm.item.amount_in_excess = vm.amountInExcess;
        vm.item.received_payment_documents = setReceivedPaymentDocuments();

        vm.sendingForm = true;
        ReceivedPaymentService.saveReceivedPayment(vm.item).then(function (data) {
          let status = data.status;
          let response = data.response;

          if (status) {
            // Success
            setItemOptions(response);

            vm.onReceivedPaymentSaved({ item: response });
          } else {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
            vm.formErrors = true;
          }

          vm.sendingForm = false;
        });
      };

      if (!vm.amountInExcess) {
        createPayment();
      } else {
        let params = {
          mode: 'warning',
          title: 'AMOUNT_IN_EXCESS',
          body: 'AMOUNT_IN_EXCESS_NOTE',
        };

        ModalWindowConfirmService.open(params, createPayment);
      }
    };

    vm.cancel = function () {
      if (vm.editMode) {
        // cancelEdit();
        vm.item = vm.originalItem;

        setItemOptions(vm.item);

        return;
      }

      vm.onReceivedPaymentCanceled();
    };

    vm.filterByDocNumberType = function () {
      let filterDocumentValues = [];
      let selectedDocument;
      let filteredDocuments = [];

      if (vm.filterByDocumentType === undefined || vm.filterByDocumentNumber === undefined) {
        return;
      }

      if (vm.filterByDocumentType.length > 0) {
        for (var i = 0; i < vm.receivedPaymentDocumentsCopy.length; i++) {
          selectedDocument = vm.receivedPaymentDocumentsCopy[i];

          selectedDocument.pay_in_full = false;

          for (var x = 0; x < vm.filterByDocumentType.length; x++) {
            filterDocumentValues = vm.filterByDocumentType[x].value;

            if (selectedDocument.type === filterDocumentValues) {
              if (vm.receivedPaymentDocuments.pay_in_full) {
                selectedDocument.pay_in_full = true;
              }
              filteredDocuments.push(selectedDocument);
            }
          }
        }

        vm.receivedPaymentDocuments = filteredDocuments;
      }

      if (vm.filterByDocumentNumber !== '') {
        const matcher = new RegExp(`^${vm.filterByDocumentNumber.toUpperCase()}`, 'g');

        if (filteredDocuments.length === 0 && vm.filterByDocumentType.length > 0) {
          vm.receivedPaymentDocuments = filteredDocuments;
        } else {
          vm.receivedPaymentDocuments = vm.receivedPaymentDocumentsCopy.filter((doc) =>
            doc.number.match(matcher)
          );
        }
      }
      if (vm.filterByDocumentNumber === '' && vm.filterByDocumentType.length === 0) {
        vm.receivedPaymentDocuments = vm.receivedPaymentDocumentsCopy;
      }

      calculateAmountApplied();
    };

    vm.selectPaymentMethod = function (paymentMethod) {
      vm.paymentMethod = paymentMethod;
      vm.receivedPayment.payment_method_id = paymentMethod.id;
    };

    // private methods
    // -----------------------
    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') vm.editReceivedPayment();

      setCompanyData(vm.company);

      setPaymentDocuments(item.received_payment_documents);

      vm.originalItem = angular.copy(item); // store server data
    }

    function setPaymentDocuments(receivedPaymentDocuments) {
      vm.receivedPaymentDocuments = [];
      vm.minTotalAmount = 0;
      vm.totalPrice = 0;

      receivedPaymentDocuments
        .filter((item) => item.document)
        .forEach((payment) => {
          let document_id;
          let document_date;
          // let payment_date;
          let type;
          let number;
          let total_price;
          let balance;
          let previousAmount;
          let newBalance;

          document_id = payment.document.document_id;
          document_date = payment.document.document_date;
          // payment_date = payment.date;
          type = payment.document.type;
          number = payment.document.number;
          total_price = payment.document.total_price;
          balance = payment.balance;
          newBalance = payment.balance - payment.amount;
          previousAmount = payment.amount;

          vm.receivedPaymentDocuments.push({
            id: payment.id,
            amount: payment.amount,
            document_id: document_id,
            document_date: document_date,
            type: type,
            number: number,
            total_price: total_price,
            newBalance: newBalance,
            balance: balance,
            previousAmount: previousAmount,
          });

          vm.minTotalAmount += vm.UtilService.roundNum(payment.balance_due);
          vm.totalPrice += vm.UtilService.roundNum(payment.document.total_price);
        });

      vm.receivedPaymentDocumentsCopy = angular.copy(vm.receivedPaymentDocuments);

      calculateAmountApplied();
    }

    function setCompanyData(company) {
      if (!company) {
        getCompany();
      } else {
        vm.incomingPaymentMethods = company.payment_methods.filter((x) => x.incoming);
        vm.paymentMethod = vm.incomingPaymentMethods.find(
          (x) => x.code === vm.item.payment_method_code
        );
        vm.user = company.users.find((x) => x.id === vm.item.user_id);
      }
    }

    function getCompany() {
      vm.loadingCompany = true;

      companyService
        .getCompany(vm.item.company_id, {
          skip_check_role: true,
          lang: userLanguageCode,
        })
        .subscribe((response) => {
          vm.company = response;
          vm.incomingPaymentMethods = vm.company.payment_methods.filter((x) => x.incoming);

          if (vm.item.payment_method_code) {
            vm.paymentMethod = vm.incomingPaymentMethods.find(
              (x) => x.code === vm.item.payment_method_code
            );
          }

          vm.user = vm.company.users.find((x) => x.id === vm.item.user_id);

          vm.loadingCompany = false;
        });
    }

    function getDocumentTypes() {
      if (vm.documentTypes) return;

      let params = {
        get: 'active',
        transaction_type: 'received_payments',
        skip_check_role: true,
      };

      vm.loadingDocumentTypes = true;
      DocumentTypeService.getDocumentTypes(params).then(function (data) {
        vm.documentTypes = data.items;

        // Preload default document type on create
        if (vm.createMode) {
          vm.documentType = vm.UtilService.findItemInArray(vm.documentTypes, 'is_default', true);
          vm.item.document_type_id = vm.documentType.id;
        } else {
          vm.documentType = vm.UtilService.findItemInArray(
            vm.documentTypes,
            'id',
            vm.item.document_type_id
          );
        }

        vm.lastDocumentTypeId = vm.documentType.id;

        setPaymentDatePicker(vm.documentType);

        vm.loadingDocumentTypes = false;
      });
    }

    function calculateAmountApplied() {
      vm.amountAppliedToDocuments = 0;
      vm.minTotalAmount = 0;

      if (vm.receivedPaymentDocuments) {
        vm.receivedPaymentDocuments.forEach(function (payment) {
          if (payment.amount)
            vm.amountAppliedToDocuments += vm.UtilService.roundNum(payment.amount);

          vm.minTotalAmount += vm.UtilService.roundNum(payment.balance);
        });
      }

      validateAmounts();
    }

    function getCurrencies(companyCurrencyIds) {
      if (vm.currenciesPerCompany) return;

      let params = {
        // company_id: vm.company.id,
        get: 'per_company',
        'currency_ids[]': companyCurrencyIds,
        skip_check_role: true,
        // documentDate: null,
      };

      if (!vm.createMode) {
        params.documentDate = vm.documentDate;
      }

      vm.loadingCurrenciesPerCompany = true;
      currencyService.getCurrencies(params).subscribe((response) => {
        vm.currenciesPerCompany = response;

        // let currencyId = vm.item.currency_id || vm.company.currency_id;
        // vm.item.currency = vm.currenciesPerCompany.find((currency) => currency.id === currencyId);

        if (vm.editMode) {
          vm.selectCurrency(vm.item.currency, true);
        }

        vm.loadingCurrenciesPerCompany = false;
      });
    }

    function setPaymentDatePicker(documentType) {
      let minDate = documentType.allows_past_days ? false : moment();
      let maxDate = documentType.allows_future_days ? false : moment();

      let onChangeDate = () => {
        vm.receivedPaymentDocuments = [];
        calculateAmountApplied();
        getOpenDocuments();
      };

      vm.paymentDatePickerOptions = vm.UtilService.singleDatePickerOptions({
        minDate: minDate,
        maxDate: maxDate,
        dateDisplay: vm.dateDisplay,
        onChangeDate: onChangeDate,
      });
    }

    function resetClientInput() {
      vm.item.client_id = null;
      vm.item.currency_id = null;

      if (vm.item.payment_method_code) {
        vm.item.payment_method_code = null;
        vm.item.payment_method_id = null;
      }

      vm.receivedPaymentDocuments = [];
    }

    function getDocumentDateExchangeRate(currencyId) {
      if (vm.item.client_id === undefined) return;

      return ExchangeRateService.getDocumentDateExchangeRate(
        vm.currenciesPerCompany,
        vm.company.currency_id,
        currencyId
      ); // , vm.documentDate
    }

    function getClient(clientId) {
      ClientService.getClient(clientId, { skip_check_role: true }).then(function (data) {
        vm.selectClient(data);
      });
    }

    function getOpenDocuments() {
      if (vm.item.client_id && vm.item.date) {
        let filterCriteria = {
          client_id: vm.item.client_id,
          date_utc: vm.UtilService.currentDateUTCFormat(vm.item.date),
          by_reference_date: vm.item.date,
          currency_id: vm.item.currency.id,
          invoice_id: null,
        };

        if (vm.receivedPaymentFromInvoice) {
          filterCriteria.invoice_id = vm.selectedInvoiceId;
        }

        vm.loadingOpenPaymentDocuments = true;
        ReceivedPaymentService.searchOpenPayments(filterCriteria).then(function (data) {
          vm.receivedPaymentDocuments = data.sort((a, b) => (a.created_at < b.created_at ? 1 : -1));
          vm.minTotalAmount = 0;
          vm.totalPrice = 0;

          vm.receivedPaymentDocuments.forEach(function (receivedPaymentDocument) {
            receivedPaymentDocument.newBalance = receivedPaymentDocument.balance;
            receivedPaymentDocument.amount = 0;

            vm.minTotalAmount += vm.UtilService.roundNum(receivedPaymentDocument.balance);
            vm.totalPrice += receivedPaymentDocument.total_price;
          });

          vm.receivedPaymentDocumentsCopy = angular.copy(vm.receivedPaymentDocuments);

          vm.loadingOpenPaymentDocuments = false;
        });
      }
    }

    function validateAmounts() {
      vm.errorAmountApplied = vm.item.amount < vm.amountAppliedToDocuments;

      vm.amountInExcess = 0;
      if (!vm.errorAmountApplied && vm.item.amount > vm.amountAppliedToDocuments) {
        vm.amountInExcess = vm.item.amount - vm.amountAppliedToDocuments;
      }
    }

    function setReceivedPaymentDocuments() {
      let receivedPaymentDocuments = [];

      vm.receivedPaymentDocuments.forEach(function (paymentDocument) {
        if ((vm.createMode && paymentDocument.amount > 0) || vm.editMode) {
          let item = {
            amount: vm.UtilService.roundNum(paymentDocument.amount),
            balance: paymentDocument.balance,
            type: paymentDocument.type,
            document_id: paymentDocument.document_id,
            document_date: paymentDocument.document_date,
            payment_date: vm.item.date,
            id: null,
          };

          if (paymentDocument.id) item.id = paymentDocument.id;

          receivedPaymentDocuments.push(item);
        }
      });

      return receivedPaymentDocuments;
    }

    function hideWarningMessageModal(data) {
      if (data) SessionService.hideWarningMessage('receivedPayments', data);
    }
  }
})();
